import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    readonly width?: string;
    readonly height?: string;
}

const EmptyProfileIcon: React.FC<IconProps> = ({ ...props }) => (
    <svg
        width='140'
        height='140'
        viewBox='0 0 140 140'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <g id='data_loss_prevention'>
            <mask
                id='mask0_2377_12541'
                type='alpha'
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='140'
                height='140'
            >
                <rect id='Bounding box' width='140' height='140' fill='#D9D9D9' />
            </mask>
            <g mask='url(#mask0_2377_12541)'>
                <path
                    id='data_loss_prevention_2'
                    d='M63.1183 54.7429C65.6645 54.7429 67.8219 53.8529 69.5904 52.0727C71.3588 50.2926 72.2431 48.1294 72.2431 45.5831C72.2431 43.0379 71.353 40.8805 69.5729 39.111C67.7927 37.3426 65.6295 36.4583 63.0833 36.4583C60.538 36.4583 58.3807 37.3484 56.6112 39.1285C54.8427 40.9087 53.9585 43.0719 53.9585 45.6181C53.9585 48.1644 54.8486 50.3217 56.6287 52.0902C58.4088 53.8587 60.572 54.7429 63.1183 54.7429ZM63.2306 78.0763C66.5993 78.0763 69.8791 77.4249 73.07 76.1221C76.2608 74.8183 79.0851 72.9536 81.5429 70.5279C78.5066 68.845 75.4461 67.6069 72.3612 66.8135C69.2763 66.0212 66.2085 65.625 63.1577 65.625C59.7695 65.625 56.4863 66.0309 53.3081 66.8427C50.1299 67.6535 47.2842 68.882 44.771 70.5279C47.3192 72.9293 50.1809 74.7877 53.3562 76.1031C56.5325 77.4185 59.8239 78.0763 63.2306 78.0763ZM123.33 122.22L91.83 90.72C87.7914 94.0178 83.3527 96.6238 78.5139 98.5381C73.6761 100.452 68.5326 101.41 63.0833 101.41C50.8158 101.41 40.3945 97.1226 31.8195 88.5486C23.2455 79.9745 18.9585 69.5474 18.9585 57.2673C18.9585 44.9881 23.2455 34.561 31.8195 25.986C40.3945 17.412 50.8216 13.125 63.1008 13.125C75.3809 13.125 85.808 17.412 94.382 25.986C102.956 34.561 107.243 44.9823 107.243 57.2498C107.243 62.6991 106.286 67.8524 104.372 72.7096C102.457 77.5668 99.8513 82.0147 96.5535 86.0533L127.997 117.496L123.33 122.22ZM63.1737 94.7917C73.5357 94.7917 82.3683 91.1162 89.6716 83.7652C96.974 76.4133 100.625 67.5563 100.625 57.1944C100.625 46.8334 96.9779 38.0013 89.6833 30.6979C82.3887 23.3946 73.5279 19.7429 63.1008 19.7429C52.7884 19.7429 43.9563 23.3907 36.6043 30.6863C29.2524 37.9808 25.5764 46.8412 25.5764 57.2673C25.5764 67.5806 29.2524 76.4133 36.6043 83.7652C43.9563 91.1162 52.8127 94.7917 63.1737 94.7917Z'
                    fill='#CEBDE6'
                />
            </g>
        </g>
    </svg>
);

export { EmptyProfileIcon };
